import styled from 'styled-components';
import { Card as ShrikeCard } from '@perch-labs/shrike';
import { margin, padding, border, breakpointStyles } from './utils';

export const Card = styled(ShrikeCard)<StyleProps>`
  background: ${props => props.theme.colors.background[props.background]};
  ${border};
  ${margin}
  ${padding}
  ${breakpointStyles(margin)}
  ${breakpointStyles(border)}
`;
